import * as z from "zod";
import en from "zod/v4/locales/en.js";

z.config(en());

export const projectTypes = [
  {
    type: "Website",
    description: "A static website which exposes your business to the world.",
  },
  {
    type: "Application",
    description:
      "A fully featured app which brings your business idea to life.",
  },
];

export const projectRequestFormSchema = z.object({
  projectType: z.enum<string[]>(
    projectTypes.map((projectType) => projectType.type),
    {
      error: "Please select one of the project types.",
    },
  ),
  budget: z.number().int().min(250).max(10000),
  dateNeededBy: z.date({ error: "Please provide a valid date." }),
  description: z.string().min(10, {
    error: "Your description is too short.",
  }),
  name: z.string().min(1, { error: "Your name is too short." }),
  email: z.email({ error: "Your email address is invalid." }),
});

/**
 * The form data for a project request form
 */
export type ProjectRequestFormData = z.infer<typeof projectRequestFormSchema>;
